import './Spinner.css';

interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
}

function Spinner({ size = 'medium' }: SpinnerProps) {
  return (
    <div className={`spinner-container spinner-${size}`}>
      <div className="spinner"></div>
    </div>
  );
}

export default Spinner;
